'use client';
import React from 'react';
import GardeniaContainer from '../../GardeniaContainer';
import cn from './style.module.scss';

export default function WelcomeAbout(props: any) {
  const { t } = props;
  return (
    <div
      className={cn.launchGRDAbout}
      style={{
        backgroundImage: `url(${props.aboutBgImg.url})`,
      }}
    >
      <GardeniaContainer>
        <div className={cn.aboutGRDContent}>
          <div className={cn.aboutGRDContent__data}>
            <h2>{t['yasWelcomeHeading']}</h2>
            <p>{t['yasWelcomeContent']}</p>
          </div>
        </div>
      </GardeniaContainer>
    </div>
  );
}
